module.exports = __webpack_public_path__ + "img/ShinyChampmandi.d4b735d6.png";